import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import style from './ContactlessEdit.module.css';
import Modal from "../../../components/comm/Modal"
import ToastPopup from '../../../components/comm/ToastPopup';
import { actionLogOut, actionRemoveUser, formatDate, getAgeByBirthday } from '../../../assets/js/comm';



const ContactlessEdit = () => {

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);  //모달창
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const logOutBtn = ()=> {
        setIsOpen(!isOpen);
    }

    const handleLogout = () => {
        actionLogOut(loginUser);
    };


    return (
        <>

            <HeadSub title="My Info" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['content-box']}>
                        <strong>Basic Information</strong>
                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>Name</p>
                                    <div className={style['right']}>
                                        <span>{loginUser !== null ? loginUser?.usrNm : ""}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>Date of Birth</p>
                                    <div className={style['right']}>
                                        <span>{loginUser !== null ? formatDate(loginUser?.brthdy) : ""} (Age {loginUser !== null ? getAgeByBirthday(loginUser?.brthdy) : ""})</span>
                                    </div>
                                </li>
                                <li>
                                    <p>Service <br />Unique Code</p>
                                    <div className={style['right']}>
                                        <span>{loginUser !== null ? 'AFTCR'+loginUser?.usrInfoId+'DGTP' : ""}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>ID</p>
                                    <div className={style['right']}>
                                        <span>{loginUser !== null ? loginUser?.usrId : ""}</span>
                                    </div>
                                </li>
                                <li>
                                    <p>Password</p>
                                    <div className={style['right']}>
                                        <button className='btn' data-btn-type="fill-main" data-btn-size='xsmd' onClick={()=> navigate(URL.NONFACE_CHANGEPASSWORD)}>
                                            <span>Change Password</span>
                                        </button>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>

                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className={style['btn-group']}>
                                <button onClick={logOutBtn}>
                                    <span>Log Out</span>
                                </button>
                                <button onClick={()=> navigate(URL.NONFACE_WITHDRAW)}>
                                    <span>Delete Account</span>
                                </button>
                            </div>

                        </div>
                    </div>


                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p>Are you sure you want to log out?</p>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={() => setIsOpen(false)}>
                                <span>No</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleLogout}>
                                <span>Yes</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                />
            )}
        </>
    );
};

export default ContactlessEdit;
